import React from "react";

const ErrorPage = () => {
  return <p>Kod QR yang anda guna bukanlah Kod QR wakaf yang betul.</p>;
};

export default ErrorPage;
